import { Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CmpButton,
  CmpDatePicker,
  CmpDatePickerField,
  CmpInputField,
  CmpSelectBox,
  CmpSelectField,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../../Component/Common/ReuseableComponent/GCToggleSearch";
import EasyBinTransfer_Breadcrumbs from "../../EasyBinTransfer_Breadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { Src_Set } from "../../SliceEasyBinTransfer";
import { useNavigate } from "react-router-dom";
import {
  GetDelete,
  GetSrc,
  fBinNameFromKey,
  fIsEnable,
} from "../../EasyBinTransferAction";
import { fAlertToast } from "../../../../Utility/Utilitys";

export default function EasyBinTransfer() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);

  const vRdxSrc = useSelector((state) => state.SliceEasyBinTransfer.value.Src);

  const onChangeInput = (e) => {
    dispatch(
      Src_Set({
        ...vRdxSrc,
        [e.target.name]: e.target.value,
      })
    );
  };
  const xfocus=(e)=>{
    if((e.key === "Enter" || e?._reactName === "onClick") && vRdxSrc.BinCodeFrom !=''){
      // document.getElementsByName("BarCode")[0]?.focus()
      document.getElementById('Next').click();
      
    }   
  }
  const FocusOnLoad = useRef(null);
  useEffect(() => {
    FocusOnLoad.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex my-3">
        <EasyBinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        <div className="BinTransferData">
          <div className="gridStyle">
            <Grid
              container
              columnSpacing={1}
              rowSpacing={2}
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans ID"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"transId"}
                  xValue={vRdxSrc.DocNo}
                  xReadOnly={true}
                  xOnChange={() => {}}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Trans Date"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpDatePickerField
                  xValue={vRdxSrc.Date}
                  xOnChange={(newValue) =>
                    dispatch(
                      Src_Set({
                        ...vRdxSrc,
                        Date: newValue.$d,
                      })
                    )
                  }
                  xName={"Date"}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              <Grid item xs={8} sm={9} md={8} lg={8}>
                <CmpSelectField
                  xValue={vRdxSrc.LocCode}
                  xOnChange={(event) => onChangeInput(event)}
                  xName={"LocCode"}
                  xData={vRdxuserLoc}
                  xDisable={true}
                />
              </Grid>
              <Grid item xs={3.5} sm={2} md={3} lg={3}>
                <CmpTypographyField xcomponent={"span"} xText={"Bin From"} />
              </Grid>
              <Grid item xs={0.5} sm={1} md={1} lg={1}>
                <CmpTypographyField xcomponent={"span"} xText={":"} />
              </Grid>
              {/* <Grid item xs={3} sm={4} md={3} lg={3}>
                <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinCodeFrom"}
                  xValue={vRdxSrc.BinCodeFrom}
                  xReadOnly={true}
                  xOnChange={() => {}}
                />
              </Grid> */}
              <Grid item xs={8} sm={9} md={8} lg={8}>
                {/* <CmpInputField
                  xType={"text"} // text/number/password
                  xName={"BinNameFrom"}
                  xValue={vRdxSrc.BinNameFrom}
                  xReadOnly={true}
                  xOnChange={() => {}}
                /> */}
                <GCToggleSearch
                  xref={FocusOnLoad}
                  xtabIndex={"25"}
                  xName={"BinNameFrom"}
                  xType={"text"}
                  xValue={vRdxSrc.BinNameFrom}
                  xOnKeyUp={async (e) => {
                    await fBinNameFromKey(e, dispatch,xfocus);
                  }}
                  xReadOnly={fIsEnable() || vRdxSrc.DocNo != 0 ? true : false}
                  xOnChange={(event) => onChangeInput(event)}
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={async (e) => {
                    await fBinNameFromKey(e, dispatch,xfocus);
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              className="mt-2"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                  xbtnName="Delete"
                  xOnClick={async () => {
                    await GetDelete(navigate);
                  }}
                  xDisabled={fIsEnable()}
                />
              </Grid>
              <Grid
                item
                lg={6}
                md={6}
                xs={6}
                className="bintransfet-data-load-btn"
              >
                <CmpButton
                xId="Next"
                  xbtnName="Next"
                  xOnClick={async () => {
                    if (vRdxSrc.BinCodeFrom == "") {
                      fAlertToast("FAILED", "Bin From Should not be empty");
                      return;
                    } else {
                      if (vRdxSrc.DocNo == 0) {
                        let resp = await GetSrc(dispatch);
                        resp.length > 0 && navigate("/EasyBinTransferDetail");
                      } else {
                        navigate("/EasyBinTransferDetail");
                      }
                    }
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}
